import { IRowCustomProperty } from "common/interfaces";
import { v4 as uuidv4 } from "uuid";

class Service {
  addBlankRowProperty(customProperties: IRowCustomProperty[]) {
    if (this.labelIsUnique("", customProperties)) {
      const newId = uuidv4().replace(/-/g, "");
      const blankProperty = { id: newId, label: "", value: "" };
      customProperties.push(blankProperty);
    }
    return customProperties;
  }

  setRowCustomPropertyLabel(
    rowCustomProperties: IRowCustomProperty[],
    id: string,
    label: string
  ): IRowCustomProperty[] {
    const property = this.findRowPropertyById(rowCustomProperties, id);
    if (
      property &&
      this.canSetLabel(rowCustomProperties, property.label, label)
    ) {
      property.label = label;
    }
    return rowCustomProperties;
  }

  setRowCustomPropertyValue(
    rowCustomProperties: IRowCustomProperty[],
    id: string,
    value: string
  ): IRowCustomProperty[] {
    const property = this.findRowPropertyById(rowCustomProperties, id);
    // So atualiza se for um valor diferente
    if (property && value !== property.value) {
      property.value = value;
    }
    return rowCustomProperties;
  }

  canSetLabel(
    customProperties: IRowCustomProperty[],
    oldLabel: string,
    newLabel: string
  ): boolean {
    const hasLabel = customProperties.some((cp) => cp.label === oldLabel);
    if (!hasLabel) return false;

    if (newLabel !== oldLabel) {
      const hasSameName = newLabel.toLowerCase() === oldLabel.toLowerCase(); // So alterou as letras de maiusculo para minusculo
      const nameIsUnique = this.labelIsUnique(newLabel, customProperties); // Ou Nome eh diferente e unico

      return hasSameName || nameIsUnique;
    }
    return true;
  }

  private labelIsUnique(label: string, elements: IRowCustomProperty[]) {
    if (!elements)
      throw new Error(
        "CustomPropertyService.isUnique: Parameter 'elements' is not a valid array."
      );
    const idx = elements.findIndex(
      (el) => String(el.label).toLowerCase() === String(label).toLowerCase()
    );
    return idx < 0;
  }

  findRowPropertyById(
    customProperties: IRowCustomProperty[],
    id: string
  ): IRowCustomProperty | undefined {
    if (!customProperties) return;
    return customProperties.find((p) => p.id === id);
  }

  removeRowProperty(
    customProperties: IRowCustomProperty[],
    id: string
  ): IRowCustomProperty[] {
    return customProperties.filter((prop) => prop.id !== id);
  }
}

export const RowCustomPropertyService = new Service();



// WEBPACK FOOTER //
// ./src/modules/customProperties/RowCustomPropertyService.ts